export const isEnglishLocale = (locale: string): boolean => {
	const lowerCaseLocale = locale.toLowerCase();
	// English locale or starts with 'en-', `en-US`, `en-GB`, etc.
	return lowerCaseLocale === 'en' || lowerCaseLocale.startsWith('en-');
};
